/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { FormHandles } from '@unform/core';
import DepartamentosService from '../../../../services/departamentos';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';

interface CreateOrderByNumberProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleAdd(data: any): void;
}

const schema = yup.object().shape({
  // departamento: yup.string().required('Departamento é obrigatório'),
  numero: yup.string().required('Número de dias é obrigatório'),
});

const CreateOrderByNumber: React.FC<CreateOrderByNumberProps> = ({
  handleClose,
  handleAdd,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const services = { DepartamentosService: new DepartamentosService() };
  const [loading, setLoading] = useState<boolean>(false);
  const [departamentos, setDepartamentos] = useState<any>([]);

  const handleGetDepartamentos = useCallback(async () => {
    try {
      const response = await services.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formTableRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });

      setLoading(true);
      await handleAdd(data);
      setLoading(false);
      handleClose();
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formTableRef.current?.setErrors(errors);
      }
      setLoading(false);
    }
  }, []);

  const departamentosOptions = useMemo(() => {
    const options = departamentos.map((dep: any) => {
      return { value: dep.CodigoDepartamento, label: dep.Nome };
    });

    return options;
  }, [departamentos]);

  useEffect(() => {
    handleGetDepartamentos();
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formTableRef} onSubmit={handleSubmit}>
            <Select
              name="departamento"
              label="Departamento"
              placeholder="Selecione o departamento"
              schema={schema}
              options={departamentosOptions}
            />
            <Input
              name="numero"
              type="number"
              label="Número de dias"
              className="numberInput"
              rounded={false}
              schema={schema}
              placeholder="Digite o numero de dias"
            />
            <div className="buttonsContainer">
              <Button color="orange" padding="1" type="submit">
                Confirmar
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default CreateOrderByNumber;
